import {Route} from "interfaces";
import {AuthLayout} from "components";
import {Navigate} from "react-router-dom";
import {Fragment} from "react/jsx-runtime";
import {
  Home,
  Login,
  Client,
  Page404,
  Privacy,
  Clients,
  Credits,
  Payments,
} from "pages";

export const authRoutes: Route[] = [
  {
    path: "/",
    element: <Navigate to="/resume" />,
    label: "",
  },
  {
    path: "/resume",
    element: <Home />,
    label: "Resumén",
  },
  {
    path: "/clients",
    element: <Clients />,
    label: "Usuarios",
  },
  {
    path: "/clients/:clientId",
    element: <Client />,
    label: "Usuario",
  },
  {
    path: "/credits",
    element: <Credits />,
    label: "Créditos",
  },
  {
    path: "/payments",
    element: <Payments />,
    label: "Pagos",
  },
  /************************************
   * 🛑 404
   ************************************/
  {
    path: "*",
    element: <Page404 />,
    label: "link.404",
  },
];

export const welcomeRoutes: Route[] = [
  {
    path: "/",
    element: <Login />,
    label: "Inicio de sesión",
  },
  {
    path: "/terms-and-conditions",
    element: <Privacy />,
    label: "Términos y condiciones",
  },
  /************************************
   * 🛑 404
   ************************************/
  {
    path: "*",
    element: <Page404 />,
    label: "link.404",
  },
];

export function navigationConfig(isLogged: boolean): {
  routes: Route[];
  Layout: typeof AuthLayout | typeof Fragment;
} {
  const Layout = isLogged ? AuthLayout : Fragment;
  const routes = isLogged ? authRoutes : welcomeRoutes;
  return {routes, Layout};
}
